import * as React from 'react';
import { Paper, type PaperProps, styled } from '@mui/material'
import type { ComponentType } from 'react'

export type RootProps = PaperProps

export const Root = styled(
  props => {
    return <Paper elevation={4} {...props} />
  },
  {
    slot: 'Root',
  },
)<RootProps>(({ theme }) => ({
  flex: 1,
  position: 'relative',
  display: 'grid',
  gridTemplateRows: 'auto 1fr auto',
  maxHeight: '100%',

  backgroundColor: theme.vars.palette.background.default,
  borderRadius: theme.spacing(1),
})) as ComponentType<RootProps>
